// extracted by mini-css-extract-plugin
export default {"centreAlign":"UsersList_centreAlign__qI7T6"};